<template>
    <app-layout>
        <div class="panel-container row align-center">
            <panel >
                <h2 slot="header">Atjaunot paroli</h2>
                <form v-if="status === ''" role="form" method="POST" @submit.prevent="reset()" novalidate @keydown="errors.remove('generic')" >
                    <div class="content">
                        <label :class="{ 'is-invalid-label': errors.has('email') }">
                            <input type="email" v-model="form.email" name="email" v-validate="'required|email'" placeholder="E-pasts"
                                   :class="{ 'is-invalid-input': errors.has('email') }"/>
                            <span class="form-error is-visible" v-if="errors.has('email')">{{ errors.first('email') }}</span>
                        </label>

                        <label :class="{ 'is-invalid-label': errors.has('password') }">
                            <input type="password" v-model="form.password" name="password" v-validate="'required'" placeholder="Jaunā parole..."
                                   :class="{ 'is-invalid-input': errors.has('password') }"/>
                            <span class="form-error is-visible" v-if="errors.has('password')">{{ errors.first('password') }}</span>
                        </label>

                        <label :class="{ 'is-invalid-label': errors.has('password_confirmation') }">
                            <input type="password" v-model="form.password_confirmation" name="password_confirmation" v-validate="'required|confirmed:password'" placeholder="Atkārtota parole..."
                                   :class="{ 'is-invalid-input': errors.has('password_confirmation') }"/>
                            <span class="form-error is-visible" v-if="errors.has('password_confirmation')">{{ errors.first('password_confirmation') }}</span>
                        </label>

                        <span class="form-error is-visible" v-if="errors.has('generic')">{{ errors.first('generic') }}</span>

                        <div class="text-center">
                            <button class="large primary button" type="submit" value="Sūtīt" :disabled="errors.any()">Saglabāt</button>
                        </div>
                    </div>
                </form>
                <p v-else>{{ status }}</p>
            </panel>
        </div>
    </app-layout>
</template>

<script>
    import auth from '../../../api/auth'
    import { Form } from '../../../modules/forms/Form'
    import AppLayout from '../../../layouts/AppLayout'
    import Panel from '../../../components/Panel'

    export default {
        name: 'reset',

        props: ['token'],

        data() {
            return {
                status: '',

                form: new Form({
                    token: '',
                    email: '',
                    password: '',
                    password_confirmation: ''
                }),
            }
        },

        methods: {
            /**
             * Reset password. Set response status and reset form data.
             */
            reset() {
                this.form.token = this.token

                auth.reset(this.form.data())
                    .then(response => {
                        console.log('response', response.data)
                        this.status = response.data.status
                    }, response => {

                        const errors = response.data.errors

                        // Record errors for available fields only
                        for (let field in errors) {
                            if (!errors.hasOwnProperty(field)) continue;

                            if (this.form.hasOwnProperty(field)) {
                                this.errors.add(field, errors[field][0], 'auth')
                            }
                        }
                    })
                    .catch(error => {
                        console.log('error', error.response.data)
                    });

                //this.form.reset()
                //this.$validator.reset();
            }
        },

        components: {AppLayout,Panel}
    }
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// resources/assets/js/views/auth/password/Reset.vue